import { connect } from 'react-redux';
import { compose, withHandlers, withProps, branch, renderNothing } from 'recompose';
import { prop } from 'ramda';
import { changeCurrentStep } from '@olxbr/mojo-jojo/actions/meta';
import { getCurrentStep, getDefaultStep, getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';
import { trackSwitchStep } from '../../core/services/tracking';

import BackButton from './BackButton';

const getAdId = prop('legacyAdId');
const getListId = prop('listId');
const getName = prop('name');
const getFunnelId = prop('funnelId');

const mapStateToProps = state => ({
  adId: getAdId(getAdData(state)),
  listId: getListId(getAdData(state)),
  currentStep: getName(getCurrentStep(state)),
  defaultStep: getName(getDefaultStep(state)),
  pointOfSale: getName(getPOSData(state)),
  funnelId: getFunnelId(getPOSData(state)),
  hide: false,
});

const mapDispatchToProps = { changeCurrentStep };

const configureHandlers = withHandlers({
  onClick: ({
    adId,
    listId,
    pointOfSale,
    defaultStep,
    funnelId,
    ...props
  }) => () => {
    trackSwitchStep({
      adId, listId, pointOfSale, step: defaultStep, funnelId,
    });
    props.changeCurrentStep(defaultStep);
  },
});

const configureProps = withProps(props => ({
  onClick: props.onClick,
}));

const branchCurrentStep = branch(
  ({ defaultStep, currentStep }) => currentStep === defaultStep,
  renderNothing,
);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  configureHandlers,
  configureProps,
  branchCurrentStep,
)(BackButton);
